import React from 'react';
import * as echarts from 'echarts'; // 引入echarts
import ReactECharts from 'echarts-for-react';
import { graphic } from 'echarts';

interface PieChartComponentProps {
    current?: number; // 当前值
    total?: number; // 总值
    style?: React.CSSProperties; // 添加style属性
}

const PieChartComponent = (props: PieChartComponentProps) => {

    /**
     * 计算百分比
     */
    const percentage = (props.current / props.total);

    const option = {
        series: [
            {
                type: 'gauge',
                startAngle: 195,
                endAngle: -15,
                min: 0,
                max: 1,
                splitNumber: 12,
                itemStyle: {
                    // 使中间区域亮，渐变向两边变淡
                    color: {
                        type: 'linear',
                        x: 0, y: 0, x2: 1, y2: 0,
                        colorStops: [
                            { offset: 0, color: '#66A1D1' }, // 亮蓝色
                            { offset: 1, color: '#1A98FF' }  // 边缘颜色
                        ]
                    },
                    shadowColor: 'rgba(0,138,255,0.45)',
                    shadowBlur: 10,
                    shadowOffsetX: 2,
                    shadowOffsetY: 2
                },
                progress: {
                    show: true,
                    roundCap: false,
                    width: 22
                },
                pointer: {
                    icon: 'path://M2.9,0.7C2.9,0.7 3.6,1.4 3.6,2.3V4.6C3.6,5.5 2.9,6.3 2.9,6.3L2.9,6.3C2.1,6.3 1.3,5.5 1.3,4.6V2.3C1.3,1.4 2.1,0.7 2.9,0.7z',
                    length: '45%',
                    width: 15,
                    offsetCenter: [0, '-63%']
                },

                axisLine: {
                    roundCap: false,
                    lineStyle: {
                        width: 22,
                        color: [
                            [1, 'rgb(35,62,107)']  // 未完成的部分，灰色背景
                        ]
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: false
                },
                title: {
                    show: false
                },
                detail: {
                    show: false
                },
                data: [
                    {
                        value: percentage,
                    },
                ],
            }
        ]
    };

    return <ReactECharts option={option} style={{ height: '175px', width: '175px' }} />;
};

export default PieChartComponent;